import React, { useCallback, useEffect, useState } from 'react';
import cogoToast from 'cogo-toast';

import {
  useDeleteLectureContentMutation,
  useGetAcademyTopicQuery,
} from 'features/classCreation';
import CreateLectureContentModal from '../CreateLectureContentModal';
import ToggleChip from 'components/ToggleChip';

function findByContentType(academyTopicLectureContents, contentType) {
  return academyTopicLectureContents?.find(
    (topicLectureContent) =>
      topicLectureContent.lecture_content.content_type === contentType
  );
}

export default function LectureContentChip({
  academyTopicId,
  contentType,
  title,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteLectureContent, { isSuccess, error }] =
    useDeleteLectureContentMutation();

  const { academyTopicLectureContent } = useGetAcademyTopicQuery(
    academyTopicId,
    {
      selectFromResult: ({ data }) => ({
        academyTopicLectureContent: findByContentType(
          data?.data?.academy_topic_lecture_contents,
          contentType
        ),
      }),
    }
  );

  const handleModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lecture content is successfully deleted!');
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in deleting the lecture content. Please try again later!'
      );
    }
  }, [error, isSuccess]);

  const handleContentDelete = useCallback(() => {
    if (
      window.confirm('Are you sure, you want to delete this lecture content?')
    ) {
      deleteLectureContent({
        academyTopicLectureContentId: academyTopicLectureContent?.id,
        academyTopicId,
      });
    }
  }, [academyTopicId, deleteLectureContent, academyTopicLectureContent]);

  return (
    <>
      <CreateLectureContentModal
        title={title}
        handleClose={handleModalClose}
        contentType={contentType}
        academyTopicId={academyTopicId}
        isOpen={modalOpen}
      />
      <ToggleChip
        isAdded={Boolean(academyTopicLectureContent)}
        onAdd={handleModalOpen}
        onRemove={handleContentDelete}
        label={title}
        className="m-r-xs m-b-xxs"
      />
    </>
  );
}
